import { enableNetworkRetryLink } from '../src/links/NetworkErrorRetryLink';
import { enableStatusCodeRetryLink } from '../src/links/StatusCodeRetryLink';

export function enableGraphqlRetries() {
	enableNetworkRetryLink();
	enableStatusCodeRetryLink();
}
